<script>
import TemplateMixin from './mixins/TemplateMixin';
import BaseGateway from './mixins/BaseGateway';
export default {
        name: "ShopifyGateway",
        mixins: [
            TemplateMixin,
            BaseGateway
        ],        
        computed:{
            gateway(){
                return 'shopify';
            }
        }
}
</script>